import { BRAND_METADATA_BY_BRAND_NAME } from 'common/brandMetadata/brandMetadataByBrandName';
import { BrandMetadata } from 'common/brandMetadata/types';
import { baseClientEnv, BaseClientEnv } from 'common/environment/baseClientEnv';
import { FUNKIT_API_KEY_BY_BRAND_NAME } from 'common/environment/integrations/funkitApiKeyByBrandName';
import { GOOGLE_ANALYTICS_ID_BY_BRAND_NAME } from 'common/environment/integrations/googleAnalyticsIdByBrandName';
import { MICROSOFT_CLARITY_ANALYTICS_ID_BY_BRAND_NAME } from 'common/environment/integrations/microsoftClarityAnalyticsByBrandName';
import { WALLETCONNECT_PROJECT_ID_BY_BRAND_NAME } from 'common/environment/integrations/walletConnectProjectIdByBrandName';

export interface ClientEnv {
  base: BaseClientEnv;
  brandMetadata: BrandMetadata;
  isTestnetDataEnv: boolean;
  integrations: {
    walletConnectProjectId: string;
    privyAppId: string;
    isPrivyConfigured: boolean;
    isPrivyFundingAutomationEnabled: boolean;
    googleAnalyticsId: string;
    microsoftClarityAnalytics: string;
    funkitApiKey: string;
  };
}

const isTestnetDataEnv = {
  local: true,
  vertexTestnet: true,
  blitzTestnet: true,
  vertexMainnet: false,
  blitzMainnet: false,
  inkMainnet: false,
  inkTestnet: true,
}[baseClientEnv.dataEnv];

const privyAppId = process.env.NEXT_PUBLIC_PRIVY_APP_ID?.trim() ?? '';
const isPrivyFundingAutomationEnabled =
  process.env.NEXT_PUBLIC_PRIVY_FUNDING_AUTOMATION_ENABLED?.trim().toLowerCase() ===
  'true';

export const clientEnv: ClientEnv = {
  base: baseClientEnv,
  isTestnetDataEnv,
  brandMetadata: BRAND_METADATA_BY_BRAND_NAME[baseClientEnv.brandName] ??
    BRAND_METADATA_BY_BRAND_NAME.stackd,
  integrations: {
    walletConnectProjectId:
      WALLETCONNECT_PROJECT_ID_BY_BRAND_NAME[baseClientEnv.brandName] ?? '',
    privyAppId,
    isPrivyConfigured: !!privyAppId,
    isPrivyFundingAutomationEnabled,
    googleAnalyticsId:
      GOOGLE_ANALYTICS_ID_BY_BRAND_NAME[baseClientEnv.brandName] ?? '',
    microsoftClarityAnalytics:
      MICROSOFT_CLARITY_ANALYTICS_ID_BY_BRAND_NAME[baseClientEnv.brandName] ?? '',
    funkitApiKey: FUNKIT_API_KEY_BY_BRAND_NAME[baseClientEnv.brandName] ?? '',
  },
};
